import React, { useContext } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { useCookies } from 'react-cookie';
import { useLocation } from 'react-router-dom';
import StyledComponent from 'styled-components';

import { CookieValues, ModelNameEnum } from '../../../types';
import NavigationBarContext from './NavigationBar.context';

const bgColor = '#235373';
const textColor = '#FFF';
const NavigationBarContainer = StyledComponent.div`
  .link-img
  {
    width: 30px;
    margin-right: 10px;
  }
  .name
  {
    text-align: center;
    color: ${textColor};
    font-weight: 600;
  }
  .avatar
  {
    width: 120px;
    height: 120px;
    margin: auto;
    margin-top: 5px;
    border: 3px solid #cecfd1;
  }
  .navbar
  {
    background-color: ${bgColor};
  }
  a, .navbar-brand, .navbar-nav .nav-link
  {
    color: ${textColor} !important;

    &:hover
    {
      color: white;
    }
  }
`;

function NavigationBar({ isMobile }: { isMobile: boolean }) {
  const location = useLocation();

  const { navData, navigationItemOnSelect } = useContext(NavigationBarContext);

  const [cookies] = useCookies<'token', CookieValues>(['token']);

  const homeOnPress = () => {
    navigationItemOnSelect(null, false);
  };

  const isLoggedIn = !!cookies.token;

  return (
    <NavigationBarContainer>
      <Navbar expand="lg" variant="dark">
        <Navbar.Brand onClick={homeOnPress}>Checkin</Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav
            className="ml-auto"
            onSelect={(eventKey, _) =>
              navigationItemOnSelect(eventKey as ModelNameEnum | null, !isMobile)
            }>
            {isMobile &&
              navData?.map((item, i) => (
                <Nav.Item key={`navigation-bar-${i}-item`}>
                  <Nav.Link key={`navigation-bar-${i}-link`} eventKey={item.title}>
                    {item.icon.indexOf('.png') === -1 ? (
                      <span className={item.icon} />
                    ) : (
                      <img alt="link" className="link-img" src={require(`../../../asset/${item.icon}`)} />
                    )}
                    {item.displayName}
                  </Nav.Link>
                </Nav.Item>
              ))}
            {isLoggedIn && (
              <Nav.Item key="navigation-bar-reports-item">
                <Nav.Link key="navigation-bar-reports-link" eventKey="reports">
                  Reports
                </Nav.Link>
              </Nav.Item>
            )}
            {isLoggedIn && (
              <Nav.Item key="navigation-bar-airtable-item">
                <Nav.Link key="navigation-bar-reports-link" eventKey="airtable">
                  Airtable
                </Nav.Link>
              </Nav.Item>
            )}
            {isLoggedIn && (
              <Nav.Item key="navigation-bar-jobs-item">
                <Nav.Link key="navigation-bar-jobs-link" eventKey="jobs">
                  Jobs
                </Nav.Link>
              </Nav.Item>
            )}
            {isLoggedIn && (
              <Nav.Item key="navigation-bar-emails-item">
                <Nav.Link key="navigation-bar-emails-link" eventKey="emails">
                  Email Templates
                </Nav.Link>
              </Nav.Item>
            )}
            <Nav.Item key="navigation-bar-logout-item">
              {isLoggedIn ? (
                <Nav.Link key="navigation-bar-logout-link" href="/logout">
                  Logout
                </Nav.Link>
              ) : location.pathname === 'login' ? (
                ''
              ) : (
                <Nav.Link key="navigation-bar-logout-link" href="/login">
                  Login
                </Nav.Link>
              )}
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </NavigationBarContainer>
  );
}

export default NavigationBar;
